/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_OfflineInputs */



/**
* | output |
* | --- |
* | "Offline" |
*
* @param {Voice_Manager_Provider_OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_offline = /** @type {((inputs?: Voice_Manager_Provider_OfflineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_OfflineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Hors ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offline")
	if (locale === "it") return /** @type {LocalizedString} */ ("Offline")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Офлайн")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desconectado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("离线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフライン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफलाइन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Offline")
	return /** @type {LocalizedString} */ ("Offline")
});